var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Datalists',{staticClass:"datalists",attrs:{"usertype":_vm.usertype},on:{"downloading":function($event){_vm.dl=$event}}}),_c('footer',{staticClass:"footer"},[_vm._v("ROTARY INTERNATIONAL DISTRICT2790 ")]),(_vm.dl==1)?[_c('Animation',{attrs:{"tx":_vm.tx}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }